/** angular */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
/** end angular */

/** components */
import { LoginComponent } from './core/login/login.component';
/** end components */

/** guards */
import { BydLoginGuard, BydAuthGuard } from '@sixense/byd-auth-service';
/** end guards */

/** resolvers */
import { BydUserResolver } from '@sixense/ds-roazhon-service';
/** end resolvers */

const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [BydLoginGuard] },
  {
    path: 'main',
    canActivate: [BydAuthGuard],
    resolve: { BydUserResolver },
    loadChildren: () => import('./core/main/main.module').then((module) => module.MainModule),
  },
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  {
    path: '**',
    redirectTo: 'main',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      relativeLinkResolution: 'legacy',
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppModuleRouting {}
